export const authRole = {
  Admin: 'Admin',
  User: ['User', 'Admin'],
};

export const fileStackKey = process.env.REACT_APP_FILESTACK_KEY as string;
export const initialUrl = process.env.REACT_APP_INITIAL_URL as string; // this url will open after login
